export default __webpack_public_path__ + "static/media/wojtkow_mobile.452d6072.webp";